import React from "react";
import { Link } from "react-router";
import { RaisedButton, TextField } from "material-ui";

import connectToStores from "alt-utils/lib/connectToStores";
import AppStore from "../../stores/AppStore";
import AppActions from "../../actions/AppActions";

@connectToStores
class TicketSalesUnlocker extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      password: ""
    };

    this.submit = this.submit.bind(this);
  }

  static getStores() {
    return [AppStore];
  }

  static getPropsFromStores() {
    return AppStore.getState();
  }

  submit() {
    AppActions.unlock(this.state.password);
  }

  getStyles() {
    return {
      container: {
        textAlign: "center"
      },
      actions: {
        marginTop: 10
      },
      error: {
        color: "#FF4136"
      }
    };
  }

  render() {
    var styles = this.getStyles();

    return (
      <div style={styles.container}>
        <div>
          <TextField
            placeholder="Unlock code"
            type="password"
            name="password"
            disabled={this.state.isSubmitting}
            value={this.state.password}
            onKeyDown={e => {
              if (e.keyCode === 13) this.submit();
            }}
            onChange={e => this.setState({ password: e.target.value.trim() })}
          />
        </div>
        {this.props.unlockErrorMessage ? (
          <div style={styles.error}>{this.props.unlockErrorMessage}</div>
        ) : null}
        <div style={styles.actions}>
          <RaisedButton
            label={this.props.unlockInProgress ? "Unlocking..." : "Unlock"}
            primary={true}
            disabled={!this.state.password || this.props.unlockInProgress}
            onClick={this.submit}
          />
        </div>
      </div>
    );
  }
}

export default TicketSalesUnlocker;



// WEBPACK FOOTER //
// ./src/app/components/partials/ticket-sales-unlocker.jsx